import type { ListBuilderList } from '../../../types';
import {
	accountColumn,
	failedLookupColumn,
	licenseColumn,
	openLicenseActionColumn,
	salesColumn,
	whyHereColumn,
} from '../columns';
import { hideOtherCardFilters } from '../filter-rules';

/**
 * Number Not Found (PD-16384) — the "failed lookup" item. Active buyers holding
 * a license number the state board, asked on two separate days, says does not
 * exist, and that no other source Workd holds for the state has either
 * (`FailedLookupService`: every lookup attempt exhausted). The number is shown
 * exactly as the customer typed it, beside the stored reason; the fix is a
 * corrected number on the license, so the one action opens it.
 *
 * The population is not SQL-expressible (the exhausted predicate runs in
 * TypeScript over the mission-control absence store), so the licenses service
 * resolves it to license ids for `licenseFailedLookup: yes` — the same set the
 * dashboard card counts.
 */
export const failedLookupList: ListBuilderList = {
	id: 'compliance-failed-lookup',
	cacheTTL: 300000,
	// Tab label, deliberately short (Chris, 2026-09-20) so more tabs show in
	// the Needs Attention strip; the rest sit under More, which is accepted
	// (Chris, 2026-09-27). The full name is above and on the dashboard card.
	name: 'Not Found',
	type: 'default',
	active: true,
	sortOrder: 6,
	filterRules: {
		...hideOtherCardFilters(['licenseFailedLookup']),
		licenseActiveBuyer: {
			defaultValue: [{ id: 'yes', label: 'Buying (sale in 90 days)' }],
			locked: true,
		},
		licenseFailedLookup: {
			defaultValue: [
				{ id: 'yes', label: 'Board has no license with this number' },
			],
			locked: true,
		},
	},
	columns: [
		accountColumn,
		salesColumn,
		licenseColumn,
		failedLookupColumn,
		whyHereColumn,
		openLicenseActionColumn,
	],
	defaultSortId: 'sales-90-desc',
};
